import { c as _c } from "react/compiler-runtime";
import { Text } from '@newfront-insurance/core-ui';
import type { CurrencyOrCheckboxInputMetadata } from '@newfront-insurance/coverage-api';
import { getStringifiedFieldValue } from '@newfront-insurance/dsl-schema-ui';
import type { SchemaFieldType, SchemaInputControlCustomInputProps, CustomValue } from '@newfront-insurance/dsl-schema-ui';
import type { JSX } from 'react';
import { AddressOrState } from './address-or-state';
import { AddressDisplayField, AddressFormattedText } from '../../../../../address';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AddressValue = Record<string, any> | undefined;
export function AddressOrStateDslInput(t0) {
  const $ = _c(9);
  const {
    value,
    onChange,
    fieldPath,
    schema,
    name,
    accountUuid
  } = t0;
  if (!accountUuid) {
    let t1;
    if ($[0] !== value) {
      t1 = <AddressDisplayField address={value} width="100%" />;
      $[0] = value;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== accountUuid || $[3] !== fieldPath || $[4] !== name || $[5] !== onChange || $[6] !== schema || $[7] !== value) {
    t1 = <AddressOrState value={value} onChange={onChange} schema={schema} fieldPath={fieldPath} name={name} accountUuid={accountUuid} />;
    $[2] = accountUuid;
    $[3] = fieldPath;
    $[4] = name;
    $[5] = onChange;
    $[6] = schema;
    $[7] = value;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}

// eslint-disable-next-line react/function-component-definition
export const AddressOrStateDslDisplay: CustomValue<AddressValue, Omit<CurrencyOrCheckboxInputMetadata, 'label'>> = t0 => {
  const $ = _c(11);
  const {
    value,
    field
  } = t0;
  if (value?.address) {
    let t1;
    if ($[0] !== value.address) {
      t1 = <AddressFormattedText address={value.address} />;
      $[0] = value.address;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (value?.state) {
    return value.state;
  }
  const t1 = value?.state;
  const t2 = field.state as SchemaFieldType;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = getStringifiedFieldValue(t1, t2);
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const displayValue = t3;
  const t4 = displayValue || "-";
  let t5;
  if ($[5] !== field.color || $[6] !== field.size || $[7] !== field.testId || $[8] !== field.weight || $[9] !== t4) {
    t5 = <Text prewrap={true} size={field.size} color={field.color} weight={field.weight} testId={field.testId}>{t4}</Text>;
    $[5] = field.color;
    $[6] = field.size;
    $[7] = field.testId;
    $[8] = field.weight;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};